import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function LadderGamePage() {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const skipRef = useRef(false);

  const [participants, setParticipants] = useState([
    { id: 1, name: "", result: "" },
    { id: 2, name: "", result: "" },
    { id: 3, name: "", result: "" }
  ]);
  
  const [isAnimating, setIsAnimating] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [finalResults, setFinalResults] = useState([]);

  // ✅ 컴포넌트 안으로 이동 (participants 참조)
  const nameRow = {
    display: 'flex', justifyContent: 'flex-start', gap: '10px',
    overflowX: participants.length >= 6 ? 'auto' : 'visible',
    flexWrap: 'nowrap', paddingBottom: '4px'
  };
  const nameInput = {
    minWidth: '80px', width: '80px', flexShrink: 0,
    padding: '12px', textAlign: 'center', borderRadius: '12px',
    border: '2px solid #000', fontWeight: 'bold', fontSize: '15px'
  };
  const resInput = {
    minWidth: '80px', width: '80px', flexShrink: 0,
    padding: '10px', textAlign: 'center', borderRadius: '12px',
    border: '1px solid #ddd', background: '#F9FAFB'
  };

  const generateLadderData = (count) => {
    const lines = [];
    const stepCount = 12;
    for (let i = 0; i < stepCount; i++) {
      const col = Math.floor(Math.random() * (count - 1));
      lines.push({
        column: col,
        y: 80 + (i * 30) + (Math.random() * 15)
      });
    }
    return lines.sort((a, b) => a.y - b.y);
  };

  const drawBaseLadder = (ctx, ladderData) => {
    const canvas = canvasRef.current;
    const spacing = canvas.width / (participants.length + 1);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = '#E5E7EB';
    ctx.lineWidth = 4;
    for (let i = 0; i < participants.length; i++) {
      const x = spacing * (i + 1);
      ctx.beginPath(); ctx.moveTo(x, 50); ctx.lineTo(x, canvas.height - 50); ctx.stroke();
    }
    ladderData.forEach(line => {
      ctx.beginPath();
      ctx.moveTo(spacing * (line.column + 1), line.y);
      ctx.lineTo(spacing * (line.column + 2), line.y);
      ctx.stroke();
    });
  };

  const runGame = async () => {
    if (isAnimating) return;
    setIsAnimating(true);
    skipRef.current = false;
    setShowResult(false);

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const spacing = canvas.width / (participants.length + 1);
    const height = canvas.height;
    const ladderData = generateLadderData(participants.length);

    drawBaseLadder(ctx, ladderData);
    const tempFinal = [];

    for (let i = 0; i < participants.length; i++) {
      let curCol = i;
      let curY = 50;
      ctx.strokeStyle = `hsl(${(i * 137) % 360}, 70%, 50%)`;
      ctx.lineWidth = 6;
      ctx.beginPath();
      ctx.moveTo(spacing * (curCol + 1), curY);

      let lastLineIdx = -1;

      while (curY < height - 50) {
        if (skipRef.current) {
          curY = height - 50;
        } else {
          curY += 5;
        }

        const lineIdx = ladderData.findIndex((l, idx) =>
          idx > lastLineIdx &&
          l.y <= curY &&
          (l.column === curCol || l.column === curCol - 1)
        );

        if (lineIdx !== -1) {
          const line = ladderData[lineIdx];
          const nextCol = (line.column === curCol) ? curCol + 1 : curCol - 1;

          ctx.lineTo(spacing * (curCol + 1), line.y);
          ctx.lineTo(spacing * (nextCol + 1), line.y);

          curCol = nextCol;
          curY = line.y + 1;
          lastLineIdx = lineIdx;
        } else {
          ctx.lineTo(spacing * (curCol + 1), curY);
        }

        ctx.stroke();
        if (!skipRef.current) await new Promise(r => requestAnimationFrame(r));
      }

      tempFinal.push({
        name: participants[i].name || `팀원 ${i+1}`,
        value: participants[curCol].result || "꽝"
      });
    }

    setFinalResults(tempFinal);
    setIsAnimating(false);
    setShowResult(true);
  };

  return (
    <div style={containerStyle}>
      <button onClick={() => navigate(-1)} style={backBtn}>← 이전으로</button>
      <h2 style={{textAlign: 'center', marginBottom: '20px', fontWeight: '800'}}>🪜 사다리 타기</h2>
      <div style={nameRow}>
        {participants.map((p, idx) => (
          <input key={p.id} style={nameInput} placeholder={`팀원 ${idx + 1}`} value={p.name}
            onChange={(e) => {
              const updated = [...participants];
              updated[idx].name = e.target.value;
              setParticipants(updated);
            }}
          />
        ))}
      </div>
      <div style={canvasWrapper}>
        <canvas ref={canvasRef} width={800} height={500} style={{width: '100%', height: 'auto'}} />
      </div>
      <div style={nameRow}>
        {participants.map((p, idx) => (
          <input key={`res-${idx}`} style={resInput} placeholder={`결과 ${idx + 1}`} value={p.result}
            onChange={(e) => {
              const updated = [...participants];
              updated[idx].result = e.target.value;
              setParticipants(updated);
            }}
          />
        ))}
      </div>
      <div style={btnGrid}>
        <button onClick={() => setParticipants([...participants, {id: Date.now(), name: "", result: ""}])} style={utilBtn} disabled={isAnimating}>인원 +</button>
        <button onClick={() => participants.length > 2 && setParticipants(participants.slice(0, -1))} style={utilBtn} disabled={isAnimating}>인원 -</button>
        {isAnimating ? (
          <button onClick={() => { skipRef.current = true; }} style={skipBtn}>결과 바로보기 (SKIP)</button>
        ) : (
          <button onClick={runGame} style={startBtn}>시작하기</button>
        )}
        <button onClick={() => window.location.reload()} style={utilBtn}>초기화</button>
      </div>
      {showResult && (
        <div style={modalOverlay} onClick={() => setShowResult(false)}>
          <div style={modalContent} onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize: '24px', marginBottom: '20px', color: '#000'}}>🎊 최종 결과 🎊</h3>
            <div style={resultList}>
              {finalResults.map((r, i) => (
                <div key={i} style={resultItem}>
                  <span style={{fontWeight: '700', fontSize: '18px'}}>{r.name}</span>
                  <span style={{color: '#999'}}>━━━━━━━━</span>
                  <span style={{fontWeight: '800', color: '#E11D48', fontSize: '20px'}}>{r.value}</span>
                </div>
              ))}
            </div>
            <button onClick={() => setShowResult(false)} style={closeBtn}>확인</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ✅ 푸터 비율 고정
const containerStyle = {
  maxWidth: '800px', margin: '0 auto', padding: '60px 20px 80px',
  minHeight: '100vh', boxSizing: 'border-box',
  fontFamily: 'Pretendard, sans-serif', position: 'relative'
};

const backBtn = {
  position: 'absolute', top: '20px', left: '20px',
  padding: '8px 16px', background: '#fff',
  border: '1px solid #E5E7EB', borderRadius: '16px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
  cursor: 'pointer', fontWeight: '600'
};

const canvasWrapper = { background: '#fff', borderRadius: '24px', margin: '25px 0', padding: '15px', border: '1px solid #E5E7EB', boxShadow: '0 10px 25px rgba(0,0,0,0.05)' };
const btnGrid = { marginTop: '30px', display: 'grid', gridTemplateColumns: '1fr 1fr 2fr 1fr', gap: '12px' };
const startBtn = { padding: '16px', background: '#000', color: '#fff', border: 'none', borderRadius: '14px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' };
const skipBtn = { padding: '16px', background: '#E11D48', color: '#fff', border: 'none', borderRadius: '14px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' };
const utilBtn = { padding: '16px', background: '#fff', border: '1px solid #E5E7EB', borderRadius: '14px', cursor: 'pointer', fontWeight: '600' };
const modalOverlay = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
const modalContent = { background: '#fff', padding: '40px', borderRadius: '32px', minWidth: '400px', textAlign: 'center', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)' };
const resultList = { margin: '30px 0' };
const resultItem = { padding: '18px 0', borderBottom: '1px dashed #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' };
const closeBtn = { width: '100%', padding: '16px', background: '#000', color: '#fff', border: 'none', borderRadius: '14px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' };

export default LadderGamePage;